module.exports = __webpack_public_path__ + "assets/img/logo.cf37e4b7.svg";